import { useQuery } from '@tanstack/react-query'

import api from '@/admin/lib/api'
import type { Product } from '@/admin/types/products'

export type StockProductResolveMatch = {
  attribute: string
  value: string
  status: string
  product: Product
}

export type StockProductResolveResult = {
  query: string
  exact: boolean
  results: StockProductResolveMatch[]
}

/**
 * Reverse-lookup a stocked value (serial, unit code, ...) to the product it
 * is scoped to. Used by Find a Product so typing a serial can lock the
 * catalogue row before a product is picked.
 *
 * Deliberately left out of the cache profiles: the answer includes whether
 * the value is still available, so it is never served from cache.
 */
export function useStockProductResolve(query: string, enabled = true) {
  const trimmed = query.trim()
  return useQuery<StockProductResolveResult>({
    queryKey: ['stock-product-resolve', trimmed],
    queryFn: () =>
      api
        .get<StockProductResolveResult>('/value-stock/resolve/', {
          params: { entity: 'holding', value: trimmed },
        })
        .then((r) => r.data),
    enabled: enabled && trimmed.length >= 2,
  })
}
